import moment from 'moment';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { GLTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/greenland.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { Button, File, DateInput, Input, FileDropzone } from '../../../index.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
const RegisterVerdict = (props) => {
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [fsNo, setFsNo] = useState(props.tribunalCase.reference || 'FS');
    const [date, setDate] = useState(moment());
    const [file, setFile] = useState(null);
    const dropzoneRef = useRef(null);
    const registerVerdict = async () => {
        setLoading(true);
        try {
            if (!date) {
                throw new Error('Date is required');
            }
            await tribunalAPI.createTribunalJob({
                type: GLTribunalJobType.RegisterVerdict,
                tribunalCaseId: props.tribunalCase.id,
                data: {
                    date: date.toISOString(),
                    fileId: file?.fileId || null,
                },
                caseId: props.tribunalCase.caseId,
                reference: `${fsNo}`.trim(),
            });
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (React.createElement(FileDropzone, { style: {}, dropzoneRef: dropzoneRef, onChange: (file) => {
            setFile(file);
        } },
        React.createElement("h4", null, "Registr\u00E9r dom"),
        !props.tribunalCase.reference && (React.createElement(Input, { placeholder: lang.tribunal.fsNo, value: fsNo, onChange: (e) => setFsNo(e.target.value) })),
        React.createElement(DateInput, { allowNull: true, placeholder: "Dato for dom", value: date, onChange: (d) => setDate(d) }),
        React.createElement(Button, { onClick: () => {
                // @ts-ignore
                dropzoneRef.current?.open();
            }, size: "small", theme: "secondary", block: true }, lang.tribunal.addDocument),
        file && (React.createElement("p", null,
            React.createElement(File, { file: file, removable: true, onRemove: () => setFile(null) }))),
        React.createElement("br", null),
        React.createElement(Button, { onClick: registerVerdict, loading: loading, disabled: !date, block: true }, "Registr\u00E9r dom")));
};
export default RegisterVerdict;
//# sourceMappingURL=RegisterVerdict.js.map